import React from 'react';

interface AddImagePlaceholderProps {
  onAdd: () => void;
  isFirstPlaceholder: boolean;
}

/**
 * The tile that adds a picture.
 *
 * It was a hard grey dashed box with a filled blue button parked in the middle
 * of it — on a product with no images that is the largest, loudest thing on
 * the screen, and it read as a broken upload widget. Quiet tile, quiet label.
 */
const AddImagePlaceholder: React.FC<AddImagePlaceholderProps> = ({ onAdd, isFirstPlaceholder }) => (
  <button
    type="button"
    name="add-button"
    onClick={onAdd}
    className={`flex cursor-pointer items-center justify-center gap-1 rounded border border-dashed
      border-border bg-muted/40 text-xs font-semibold text-primary transition-colors
      hover:border-primary/60 hover:bg-muted
      ${isFirstPlaceholder ? 'image-grid-item-large' : 'image-grid-item'}`}
  >
    {/* "+ Add" on one line, as the design draws it. A plus glyph stacked above
        the word says the same thing twice in a 100px tile. */}
    + Add
  </button>
);

export default AddImagePlaceholder;
